export const configuratorFilter = [
  'configuratorGenre',
  'configuratorEngineRange',
  'configuratorPriceRange',
  'configuratorLicenceType',
  'configuratorSurfaceType',
];

export const configuratorStarted = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorStartPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorColour = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorPacks = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorColourActions',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAccessories = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorColourActions',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorSummary = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorColourActions',
  'configuratorAccessoryItems',
  'configuratorAccessoryActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorFullScreen = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorFlip = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorColourSelected = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorColourPrice',
  'configuratorColourActions',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAccessoryFilter = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorAccessoryCategory',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAccessorySearch = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorAccessoryCategoryCount',
  'configuratorTotalActions',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAccessoryInfo = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorAccessoryName',
  'configuratorAccessoryCategory',
  'configuratorAccessoryID',
  'configuratorAccessoryPrice',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAccessorySelected = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorAccessoryName',
  'configuratorAccessoryCategory',
  'configuratorAccessoryID',
  'configuratorAccessoryPrice',
  'configuratorAccessoryItems',
  'configuratorAccessoryActions',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAccessoryRemoved = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorAccessoryName',
  'configuratorAccessoryCategory',
  'configuratorAccessoryID',
  'configuratorAccessoryPrice',
  'configuratorAccessoryItems',
  'configuratorAccessoryActions',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorPackInfo = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorPackName',
  'configuratorPackID',
  'configuratorPackPrice',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorPackSelected = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorPackName',
  'configuratorPackID',
  'configuratorPackPrice',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorPackRemoved = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorPackName',
  'configuratorPackID',
  'configuratorPackPrice',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorExtraSelected = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'configuratorExtrasActions',
  'configuratorTotalActions',
  'offerPresent',
  'offerName',
];

export const configuratorExtraRemoved = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'configuratorTotalActions',
  'configuratorExtrasActions',
  'offerPresent',
  'offerName',
];

export const configuratorOfferInfo = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorExtraInfo = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorSaveAttempt = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorSaveCancel = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorSaveComplete = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAbandonAttempt = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAbandonSave = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAbandonConfirm = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorSave = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorUnsaved = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorSaveIntent = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorResetAttempt = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorResetConfirm = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorResetCancel = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorShareAttempt = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorShareConfirm = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorShareCancel = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorPriceInfo = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorFinanceInfo = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorTestRide = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorFinance = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorPrint = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorAccessoryConflict = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorAccessoryItems',
  'configuratorAccessoryCategory',
  'configuratorStartPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorFilter1 = ['configuratorFilter'];
export const configuratorFilter2 = ['configuratorFilter'];
export const configuratorFilter3 = ['configuratorFilter'];
export const configuratorFilter4 = ['configuratorFilter'];
export const configuratorFilter5 = ['configuratorFilter'];
export const configuratorFilter6 = ['configuratorFilter'];

export const configuratorGarageAttempt = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorGarageCancel = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorGarageLoad = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorGarageFindDealer = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorFinalPrice',
];

export const configuratorGarageBuyNow = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'productCode',
];

export const configuratorTrayFinance = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'productCode',
];

export const configuratorSumFinance = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'productCode',
];

export const configuratorSumPrim = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'productCode',
];

export const configuratorSumSec = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'productCode',
];

export const configuratorSendDealerOpen = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorColourActions',
  'configuratorAccessoryItems',
  'configuratorAccessoryActions',
  'configuratorPackName',
  'configuratorPackID',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const configuratorSendDealerSuccess = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorColourActions',
  'configuratorAccessoryItems',
  'configuratorAccessoryActions',
  'configuratorPackName',
  'configuratorPackID',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const getDirections = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'tradeIn',
  'dealerName',
];

export const saveQuoteCancel = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorColourActions',
  'configuratorAccessoryItems',
  'configuratorAccessoryActions',
  'configuratorPackName',
  'configuratorPackID',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
];

export const saveQuoteComplete = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorBikeColour',
  'configuratorColourActions',
  'configuratorAccessoryItems',
  'configuratorAccessoryActions',
  'configuratorPackName',
  'configuratorPackID',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
];

export const configuratorCalPrim = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
  'financeProduct',
  'ctaText',
];

export const configuratorCalSec = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorColourActions',
  'configuratorAccessoryActions',
  'configuratorPackActions',
  'configuratorStartPrice',
  'configuratorFinalPrice',
  'configuratorValue',
  'configuratorTotalActions',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
  'financeProduct',
  'ctaText',
];
